import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import { ActionContext } from 'actions/context';
import ModalService from 'services/modal';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Http from 'services/http2';
import SupplierService from 'services/supplier.ts';

function MallIntroduceDetail(props) {
  const Config = {
    purchase: {
      title: '内部商城引入详情',
      apiPath: '/introduce/getDetail',
      publishApiPath: '/introduce/updateStatus',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Introduce_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'inductXkNo',
      wfmCode: '1019'
    }
  };

  const style1 = {
    image: {
      width: 60,
      height: 60,
      fontSize: 50
    },
    img: {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%'
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    getList();
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  function validate() {
    let taxFlag = false;
    let categoryFlag = false;
    list.forEach(item => {
      if (Util.isEmpty(item.taxCode)) {
        taxFlag = true;
      }
      if (Util.isEmpty(item.categoryCode)) {
        categoryFlag = true;
      }
    });
    if (categoryFlag) {
      ModalService.showError('单身品类不能为空', dispatch);
      return false;
    }
    if (taxFlag) {
      ModalService.showError('单身税别不能为空', dispatch);
      return false;
    }

    return true;
  }

  //发送
  function handlePublish() {
    if (!validate()) {
      return;
    }

    let postbody = getPostbody(config.publishApiPath);
    postbody.status = 1;
    SupplierService.handleIntroducePublish(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  function getList() {
    let postbody = {
      inductXkNo: self.id,
      pageSize: 100,
      pageNum: 1,
      companyCode: companyCode,
      apiPath: '/introduce/getLineDetail'
    };

    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let lists = response.data.list || [];
        setList(lists);
      }
    });
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      inductXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">引入单号</label>
              <div className="order-detail-value">{detail.inductXkNo}</div>
            </li>
            <li>
              <label className="order-detail-label">适用公司</label>
              <div className="order-detail-value">
                {Array.isArray(detail.applyCompList) &&
                  detail.applyCompList.map((item, index) => (
                    <span key={item.applyCompanyCode + index}>
                      <span>{item.applyCompanyName}</span>
                      {<span>；</span>}
                    </span>
                  ))}
              </div>
            </li>
            <li>
              <label className="order-detail-label">工厂/BU</label>
              <div className="order-detail-value">
                {detail.profitCenterName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">说明</label>
              <div className="order-detail-value">{detail.remark}</div>
            </li>
            <li>
              <label className="order-detail-label">状态</label>
              <div
                className={
                  'u-sign ' +
                  CommonFns.getStatusClass('introduce', detail.status)
                }
              >
                {detail.statusName}
              </div>
            </li>

            {/* 审批流状态 仅开启后才显示 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批环节</label>
                <div className="order-detail-value">
                  <WorkflowStatus
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                  />
                </div>
              </li>
            )}
            {/* 审批流按钮 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批操作</label>
                <div className="order-detail-value">
                  <WorkflowButtons
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                    onChange={() => {
                      self.getDetail();
                    }}
                  />
                </div>
              </li>
            )}
          </ul>
        </div>

        {/*商城引入明细 */}
        {!Util.isEmpty(list) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[1]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>商城引入明细</label>
                <i className="icon-down" onClick={() => handleBoxState(1)}></i>
              </div>
              {boxState[1] && (
                <div className="order-detail-list">
                  <ul>
                    {list.map((item, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">项次 {index + 1}</span>
                        <div style={style1.image}>
                          {item.imageUrl ? (
                            <img
                              style={style1.img}
                              alt="complex"
                              src={item.imageUrl}
                            />
                          ) : (
                            <i className="icon-supplier"></i>
                          )}
                        </div>
                        <ul className="clearfix">
                          <li className="single">
                            商品信息：
                            {item.mroProductName === item.mroSkuName
                              ? item.mroSkuName
                              : item.mroProductName + '/' + item.mroSkuName}
                          </li>
                          <li className="single">
                            品牌：
                            {item.mroBrandName}
                          </li>
                          <li className="single">
                            供应商名称：
                            <span>{item.innerVendorName}</span>
                          </li>
                          <li className="single">
                            商品规格：
                            {item.mroPackageSpec}
                          </li>
                          {item.productCode && (
                            <li className="single">
                              内部料号：
                              {item.productCode} {item.productName}{' '}
                              {item.productScale}
                            </li>
                          )}
                          <li>
                            品类：
                            {item.categoryName}
                          </li>
                          <li>
                            单位：
                            {item.unitName}
                          </li>
                          <li>
                            交期： 生产{' '}
                            {item.deliveryTime > 1
                              ? item.deliveryTime + '个工作日'
                              : '次日'}
                          </li>
                          <li>
                            单价：
                            {formatNumber(item.price, decimalPlace.PRICE)}
                          </li>
                          <li>
                            税别：
                            {item.taxName}
                          </li>
                          <li>
                            折扣率：
                            {item.discountRate} %
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10090402') &&
            [0].includes(detail.status) &&
            workflow.data &&
            workflow.data['introduce_order_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handlePublish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

MallIntroduceDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MallIntroduceDetail);
